export class WebModal {
  constructor (App = null, settings = {}) {
    this.App = App;
    this.triggerButton = null;
    this.opened = false;
    this.settings = settings;
    this.config = {
      width: 0,
      height: 0
    };
    this.customSettings = {};
  }

  open (url) {
    $(this.settings.id).remove();

    let _modal = $('body').append(`
      <div id="modal-window" class="modal-window">
        <div class="modal-holder"></div>
      </div>`);

    _modal.find('.modal-holder').load(url, () => {
      if (this.App.blocked) return false;
      this.App.blocked = true;
      this.load();
    });
  }

  load () {
    let _modal = $(this.settings.id);
    let holder = _modal.find('.modal-holder');
    let content = _modal.find('[role=modal-main]');

    _modal.fadeIn('fast');
    _modal.unbind('click').on('click', (e) => {
      this.close();
    });

    this.opened = true;

    $(window).on('keydown.modal', (e) => {
      if (e.which === 27) {
        this.close();
      }
    });

    if (this.customSettings.closeButton !== false) {
      holder.append(this.settings.closeButton);
    }

    holder.css('max-width', content.data('width') || 'auto');
    holder.css('max-height', content.data('height') || 'auto');

    holder.on('click', (e) => {
      e.stopPropagation();
    });

    this.bindClose(this.settings.selectors.close);

    if (this.customSettings.onComplete) {
      if ($.type(this.customSettings.onComplete) === 'function') {
        this.customSettings.onComplete();
      } else {
        this.App._runFuncByName(this.customSettings.onComplete, window);
      }
    }

    this.App.blocked = false;
    this.App.bindAll(_modal);

    $(content).find('input:first').focus();
  }

  bindOpen (selector, url) {
    let that = this;

    $(selector).unbind('click');
    $(selector).on('click', function (e) {
      e.preventDefault();

      that.triggerButton = this;
      that.customSettings = {
        closeButton: $(this).data('closebut'),
        loader: $(this).attr('loader') || false,
        transition: $(this).data('transition') || null,
        onComplete: $(this).attr('on-complete') || null,
        onClose: $(this).attr('on-close') || null
      };

      if (that.App.settings.loader) {
        $(this).append(that.App.settings.loader.html);
      }

      that.open(url !== undefined ? url : $(this).attr('href'), $(this));
    });
  }

  close () {
    $(window).off('keydown.modal');

    $(this.settings.id)
      .fadeOut('fast')
      .find('.modal-content').html('');

    if (this.customSettings.onClose) {
      if ($.type(this.customSettings.onClose) === 'function') {
        this.customSettings.onClose(this.triggerButton);
      } else {
        this.App._runFuncByName(this.customSettings.onClose, window, this.triggerButton);
      }
    }
    this.opened = false;
    this.customSettings = {};
  }

  alert (msg, msgClass) {
    let _modal = $(this.settings.id);

    this.customSettings.closeButton = false;

    let html = `<div role="modal-main" class="feedback-message-modal ${msgClass}">
      <span>${msg}</span>
    </div>`;

    _modal.find('.modal-content').html(html);
    this.load();
  }

  bindClose (selector) {
    $(selector).unbind('click');
    $(selector).on('click', () => {
      this.close();
    });
  }

  bindAll (context) {
    this.bindOpen($(context).find(this.settings.selectors.open));
  }
}



// WEBPACK FOOTER //
// ./devel/js/modules/modal.js